import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a Meta Pixel `PageView` on every React-Router navigation.
 *
 * The base pixel snippet in index.html only fires `PageView` on the
 * initial HTML load. Without this, every subsequent SPA navigation
 * (e.g. /auth → /bracket) would be invisible to Meta and conversion
 * attribution would silently break.
 *
 * Skips the very first run so we don't double-count the initial load
 * (the inline snippet already fired PageView for that one).
 */
export function PixelRouteTracker() {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [pathname]);

  return null;
}
